import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { Tabs } from "@volca/ui/components/ui/tabs";
import { BusinessSettingsSidebarHeaderSkeleton } from "@/business-settings/common/business-settings-sidebar-header-skeleton";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const ReferralPaymentsSidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <BusinessSettingsSidebarHeaderSkeleton />
    <div className="flex-1 overflow-hidden">
      <Stack align="start" gap={0} className="h-full w-full">
        <Tabs className="flex w-full flex-1 flex-col gap-0 overflow-hidden px-6">
          <Stack align="start" gap={4} className="w-full pt-4">
            <Stack align="start" gap={6} className="mt-2 w-full">
              <Stack align="start" direction="row" justify="between" gap={4}>
                <Stack align="start" gap={2} className="h-[44px] w-full">
                  <Skeleton className="h-4 w-3/5"></Skeleton>
                  <Skeleton className="h-5 w-4/5"></Skeleton>
                </Stack>

                <Stack align="start" gap={2} className="h-[44px] w-full">
                  <Skeleton className="h-4 w-3/5"></Skeleton>
                  <Skeleton className="h-5 w-4/5"></Skeleton>
                </Stack>
              </Stack>

              <Stack align="start" direction="row" justify="between" gap={4}>
                <Stack align="start" gap={2} className="h-[44px] w-full">
                  <Skeleton className="h-4 w-3/5"></Skeleton>
                  <Skeleton className="h-5 w-4/5"></Skeleton>
                </Stack>

                <Stack align="start" gap={2} className="h-[44px] w-full">
                  <Skeleton className="h-4 w-3/5"></Skeleton>
                  <Skeleton className="h-5 w-4/5"></Skeleton>
                </Stack>
              </Stack>

              <Stack align="start" gap={2} className="h-[44px] w-full">
                <Skeleton className="h-4 w-20"></Skeleton>
                <Skeleton className="h-5 w-12"></Skeleton>
              </Stack>

              <Stack align="start" gap={2} className="h-[44px] w-full">
                <Skeleton className="h-4 w-20"></Skeleton>
                <Skeleton className="h-5 w-12"></Skeleton>
              </Stack>
            </Stack>
          </Stack>
        </Tabs>
      </Stack>
    </div>
  </BusinessSettingsSidebarWrapper>
);
